import { Link } from 'react-router';

import AirkeyLogo from '../../assets/airkey-logo-white.svg?react';
import grvMenu from '../../assets/grv-menu.svg';
import { EXTERNAL_URLS } from '../../constants';
import { useEntitlements } from '../../contexts/entitlementsContext';

import './Navbar.scss';
import { NavbarDropdown } from './NavbarDropdown/NavbarDropdown';
import { ThemeToggle } from './ThemeToggle/ThemeToggle';

// TODO: Update dev portal link with correct environment URLs

export const Navbar = () => {
  const { hasEntitlements } = useEntitlements();

  return (
    <header className="navbar">
      <div className="navbar-container">
        <Link to={EXTERNAL_URLS.DEVELOPER_PORTAL_HOME}>
          <div className="navbar-left">
            <AirkeyLogo className="navbar-left-airkey-logo" />
            <p className="navbar-left-title">Developer</p>
          </div>
        </Link>
        <div className="navbar-right">
          <div className="navbar-right-links">
            <Link
              className="navbar-right-link"
              to={EXTERNAL_URLS.DEVELOPER_PORTAL_HOME}
            >
              <div className="navbar-right-link-text">Home</div>
            </Link>
            {hasEntitlements && (
              <span className="navbar-right-links-internal">
                <Link
                  className="navbar-right-link"
                  to={EXTERNAL_URLS.DEVELOPER_PORTAL_DOCS}
                >
                  <div className="navbar-right-link-text">Documentation</div>
                </Link>
                <Link
                  className="navbar-right-link"
                  to={EXTERNAL_URLS.DEVELOPER_PORTAL_SANDBOX}
                >
                  <div className="navbar-right-link-text">Sandbox</div>
                </Link>
                <Link
                  className="navbar-right-link navbar-right-link-highlighted"
                  to="/"
                  aria-current="page"
                >
                  <div className="navbar-right-link-text">Download</div>
                </Link>
              </span>
            )}
            <Link className="navbar-right-link" to={EXTERNAL_URLS.AIRKEY_HOME}>
              <div className="navbar-right-link-text">AirKey.com</div>
            </Link>
            <ThemeToggle />
            {hasEntitlements && <NavbarDropdown />}
          </div>

          <div className="navbar-right-hamburger">
            <img
              className="navbar-right-hamburger-icon"
              src={grvMenu}
              alt="Hamburger dropdown"
            />
          </div>
        </div>
      </div>
    </header>
  );
};
